import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { OrganisationService } from 'src/app/services/organisation.service';
import { AdminService } from './../../../services/admin.service';
import { debounceTime, distinctUntilChanged, tap, concatMap } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators/map';
import * as jquery from 'jquery';
import { ChallengeUsers } from './challenge-interface';
import * as moment from 'moment-timezone';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-challenge-report',
  templateUrl: './challenge-report.component.html',
  styleUrls: ['./challenge-report.component.scss'],
})

export class ChallengeReportComponent implements OnInit, AfterViewInit {

    @ViewChild('searchEnterprise') searchEnterprise: ElementRef;
    @ViewChild('searchNameOrEmail') searchNameOrEmail: ElementRef;
    @ViewChild('searchVoucher') searchVoucher: ElementRef;

    hoveredDate: NgbDate | null = null;
    fromDate: NgbDate | null;
    toDate: NgbDate | null;
    fromUnixTimestamp = '';
    toUnixTimestamp = '';
    dpFromDate: NgbDate;
    dpToDate: NgbDate;
    organisation = '';
    name_or_email = '';
    voucher = '';
    usersTotal = 0;
    currentPage: number;
    lastPage: number;
    pageLinks: number[] = [];
    modalText = 'Loading...';
    users: ChallengeUsers = {
      users_completed: 0,
      total_users: 0,
      users_completed_percentage: 0,
      improved_question_1: 0,
      improved_question_2: 0,
      improved_question_3: 0,
      users: []
    }
    
    organisations = [];
    organisationVal = '0';
    vouchers = [];
    voucherVal = '0';

    constructor(
      private adminService: AdminService,
      private organisationService: OrganisationService
    ) { }

    ngOnInit(): void {
      this.loadData();
      this.organisationList();
      this.voucherList();
    }

    ngAfterViewInit(): void {
      // this.filterEnterprise();
      // this.filterVoucher();
      this.filterNameOrEmail();
    }

    filterEnterprise() {
      fromEvent(this.searchEnterprise.nativeElement, 'keyup')
        .pipe(
          map((event: any) => {
            this.organisation = event.target.value;
            return event.target.value;
          }),
          debounceTime(2000),
          distinctUntilChanged()
        )
        .subscribe((text: string) => {
          this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
          this.loadData(1, text, this.name_or_email, this.voucherVal, this.fromUnixTimestamp, this.toUnixTimestamp)
        });
    }

    filterNameOrEmail() {
      fromEvent(this.searchNameOrEmail.nativeElement, 'keyup')
        .pipe(
          map((event: any) => {
            this.name_or_email = event.target.value;
            return event.target.value;
          }),
          debounceTime(2000),
          distinctUntilChanged()
        )
        .subscribe((text: string) => {
          this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
          this.loadData(1, this.organisationVal, text, this.voucherVal, this.fromUnixTimestamp, this.toUnixTimestamp)
        });
    }

    filterVoucher() {
      fromEvent(this.searchVoucher.nativeElement, 'keyup')
        .pipe(
          map((event: any) => {
            this.voucher = event.target.value;
            return event.target.value;
          }),
          debounceTime(2000),
          distinctUntilChanged()
        )
        .subscribe((text: string) => {
          this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
          this.loadData(1, this.organisationVal, this.name_or_email, text, this.fromUnixTimestamp, this.toUnixTimestamp)
        });
    }

    onDateFromSelection(fromDate: NgbDate) {
      this.fromDate = fromDate;
      const fromDateF = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
      if (this.toDate) {
        if (this.fromDate.after(this.toDate)) {
          jquery('#dateInputFrom').val(fromDateF);
          this.fromDate = fromDate;
  
          this.toDate = null;
          this.dpToDate = null;
        } else {
          jquery('#dateInputFrom').val(fromDateF);
        }
      }
      this.onDateSelection();
    }
  
    onDateToSelection(toDate: NgbDate) {
      this.toDate = toDate;
      const toDateF = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
      if (this.fromDate) {
        if (this.toDate.before(this.fromDate)) {
          jquery('#dateInputFrom').val(toDateF);
          this.fromDate = toDate;
  
          jquery('#dateInputTo').val('');
          this.toDate = null;
          this.dpToDate = null;
        } else {
          jquery('#dateInputTo').val(toDateF);
        }
      }
      this.onDateSelection();
    }

    onDateSelection() {
      // Get the Unix Timestamp for DateFrom and DateTo
      if (this.fromDate && this.toDate) {

        // Handles From Date Conversion to timestamp
        const fromMonth = (this.fromDate.month < 10) ? '0' + this.fromDate.month : this.fromDate.month;
        const fromDay = (this.fromDate.day < 10) ? '0' + this.fromDate.day : this.fromDate.day;
        const fromYear = this.fromDate.year;
        const fromDate = fromYear + '-' + fromMonth + '-' + fromDay + ' 00:00:00';
        this.fromUnixTimestamp = moment.tz(fromDate.toString(), 'YYYY-MM-DD HH:mm:ss', moment.tz.guess()).format('X');
  
        // Handles To Date Conversion to timestamp
        const toMonth = (this.toDate.month < 10) ? '0' + this.toDate.month : this.toDate.month;
        const toDay = (this.toDate.day < 10) ? '0' + this.toDate.day : this.toDate.day;
        const toYear = this.toDate.year;
        const toDate = toYear + '-' + toMonth + '-' + toDay + ' 23:59:59';
        this.toUnixTimestamp = moment.tz(toDate.toString(), 'YYYY-MM-DD HH:mm:ss', moment.tz.guess()).format('X');
  
      }
  
      if (this.fromUnixTimestamp !== '' && this.toUnixTimestamp !== '') {
        this.modalText = 'Searching...';
        this.loadData(1, this.organisationVal, this.name_or_email, this.voucherVal, this.fromUnixTimestamp, this.toUnixTimestamp)
      }
    }
  
    clearDateFrom() {
      if (this.fromDate) {
        jquery('#dateInputFrom').val('');
        this.fromDate = null;
        this.fromUnixTimestamp = '';
        this.dpFromDate = null;
        this.loadData(1, this.organisationVal, this.name_or_email, this.voucherVal, this.fromUnixTimestamp, this.toUnixTimestamp);
      }
    }
  
    clearDateTo() {
      if (this.toDate) {
        jquery('#dateInputTo').val('');
        this.toDate = null;
        this.toUnixTimestamp = '';
        this.dpToDate = null;
        this.loadData(1, this.organisationVal, this.name_or_email, this.voucherVal, this.fromUnixTimestamp, this.toUnixTimestamp);
      }
    }

    loadData(pageNumber: number = 1, organisation: string = '', name_or_email: string = '', voucher: string = '', dateFrom: string = '', dateTo: string = '') {
      // Show progress modal
      this.showProgressModal();
      this.adminService.challengeReportList(pageNumber, organisation, name_or_email, voucher, dateFrom, dateTo)
        .pipe(
          map(userData => userData.data),
          tap(userData => {
              //console.log(userData);
              this.users = userData;
              
              this.users.users = userData.users.data;

              const totalRecords = userData.pagination?.total_records;
              this.lastPage = userData.pagination?.last_page;
              this.pageLinks = [];
              if (totalRecords > 0) {
                this.currentPage = userData.pagination?.current_page;
                for (let index = 1; index <= this.lastPage; index++) {
                  this.pageLinks.push(index);
                }
              }

              this.usersTotal = totalRecords;
          }))
        .subscribe(
          response => {
            if (response !== undefined) {
              setTimeout(() => {
                // hide progress modal
                this.hideProgressModal();
                //this.loading = false;
              }, 500);
            }
          },
          error => {
            // hide progress modal
            this.hideProgressModal();
            //this.error = true;
          }
        );
    }
  
    organisationList() {
      this.organisationService.listAll()
      .subscribe(
        data => {
          let organisations = [];
          for (let key in data.data.organisation) {
            organisations.push({key: key, value: data.data.organisation[key]});
          }
  
          organisations.sort(this.dynamicSort("value"));
  
          organisations = [{key: '0', value: 'All Enterprise'}, ...organisations];
  
          this.organisations = organisations;
  
          // hide progress modal
          this.hideProgressModal();
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
        }
      );
    }

    voucherList() {

      //console.log('this.voucherVal', this.voucherVal);

      this.organisationService.allVoucher(this.organisationVal)
      .subscribe(
        data => {
          let vouchers = [];
          for (let key in data.data.vouchers) {
            vouchers.push({key: data.data.vouchers[key]['id'], value: data.data.vouchers[key]['code']});
          }
  
          vouchers.sort(this.dynamicSort("value"));
  
          vouchers = [{key: '0', value: 'Select Voucher'}, ...vouchers];

          this.vouchers = vouchers;
  
          // hide progress modal
          this.hideProgressModal();
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
        }
      );
    }

    changeOrg() {
      this.voucherVal = '0';
      this.voucherList();
      this.loadData(1, this.organisationVal, this.name_or_email, this.voucherVal, this.fromUnixTimestamp, this.toUnixTimestamp);
    }

    changeVoucher() {
      this.loadData(1, this.organisationVal, this.name_or_email, this.voucherVal, this.fromUnixTimestamp, this.toUnixTimestamp);
    }
  
    dynamicSort(property) {
      var sortOrder = 1;
  
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
  
      return function (a,b) {
          if(sortOrder == -1){
              return b[property].localeCompare(a[property]);
          }else{
              return a[property].localeCompare(b[property]);
          }        
      }
    }

    private showProgressModal() {
      jquery('#loaderSpin').show();
    }

    private hideProgressModal() {
      jquery('#loaderSpin').hide();
    }

    paginate(pageNumber: number) {
      if (pageNumber > 0) {
        this.loadData(pageNumber);
      }
    }

}